import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EditorService} from '../../../../../services/editor.service';
import {FormBuilder, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';

@Component({
    selector: 'app-resumes-editor-settings-dialog',
    templateUrl: './resumes-editor-settings-dialog.component.html',
    styleUrls: ['./resumes-editor-settings-dialog.component.scss']
})
export class ResumesEditorSettingsDialogComponent implements OnInit {
    firstFormGroup: any;
    secondFormGroup: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private formBuilder: FormBuilder,
                public dialogRef: MatDialogRef<ResumesEditorSettingsDialogComponent>) {
        this.firstFormGroup = this.formBuilder.group({
            firstCtrl: ['', Validators.required],
        });
        this.secondFormGroup = this.formBuilder.group({
            secondCtrl: ['', Validators.required],
        });
    }

    ngOnInit(): void {
    }

    close(data?: any) {
        this.dialogRef.close(data);
    }

    save() {

    }

}
